import { SmlsButton } from '@smiles/smiles-ui-kit-react';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { formatStringsToPlural } from '../../../utils';
import { DateHighlightProps, IInfoPanel } from './types';

const InfoPanel: React.FC<IInfoPanel> = ({
  idConfirmButton,
  onClick,
  onClear,
  datesListHighlight,
  selectedDate,
  startDate,
  endDate,
  hasSelectedDate,
  disabledButton = false,
}) => {
  const { t } = useTranslation();
  const leftDates = () => {
    const dates = datesListHighlight?.filter(
      (holydays: DateHighlightProps) =>
        selectedDate?.month() === holydays.date.month() && selectedDate?.year() === holydays.date.year(),
    );
    return dates?.map((date: DateHighlightProps) => (
      <li key={date.description}>
        <span>{`${date.date.date()} - ${date.description}`}</span>
      </li>
    ));
  };

  const rightDates = useCallback(() => {
    const dates = datesListHighlight?.filter((holydays: DateHighlightProps) => {
      const newData = selectedDate?.clone();
      return newData?.add(1, 'month').month() === holydays.date.month() && newData?.year() === holydays.date.year();
    });
    // eslint-disable-next-line sonarjs/no-identical-functions
    return dates?.map((date: DateHighlightProps) => (
      <li key={date.description}>
        <span>{`${date.date.date()} - ${date.description}`}</span>
      </li>
    ));
  }, [selectedDate, datesListHighlight]);

  return (
    <div className="calendar-information-panel">
      <div className="date-information-panel">
        <ul className="date-left-side">{leftDates()}</ul>
        <ul className="date-right-side">{rightDates()}</ul>
      </div>

      <div className="action-panel">
        <div className="clear-dates-wrapper">
          {hasSelectedDate && (
            <button type="button" className="button-clear-dates" onClick={onClear}>
              Limpar Datas
            </button>
          )}
        </div>

        <div className="dates-confirmation-wrapper">
          {startDate && endDate && (
            <div className="dailies-amount">
              <span className="dailies-total">
                {t('common.text', { text: formatStringsToPlural('diária', endDate.diff(startDate, 'days')) })}
              </span>
              <span className="dates-from-to">
                {`${startDate.format('DD MMM')} - ${endDate.format('DD MMM [de] YYYY')}`}
              </span>
            </div>
          )}

          <SmlsButton
            id={idConfirmButton}
            text="Confirmar"
            className="button-confirm"
            onClick={onClick}
            disabled={disabledButton}
          />
        </div>
      </div>
    </div>
  );
};

export default InfoPanel;
